import React from 'react';
import { Rocket, Handshake, BadgeDollarSign, FlaskConical } from 'lucide-react';
export function GoToMarket() {
  return <section id="gotomarket" className="py-20 lg:py-32 bg-slate-900 relative" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-60">
        <div className="text-center mb-16" data-id="element-61">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-62">
            How We Scale
          </h2>
          <p className="text-xl text-slate-400 max-w-2xl mx-auto" data-id="element-63">
            A proven, phased approach to market penetration and infrastructure
            deployment.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-64">
          {/* Strategy Steps */}
          <div className="space-y-8" data-id="element-65">
            <div className="flex gap-4" data-id="element-66">
              <div className="w-12 h-12 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center shrink-0 text-slate-300" data-id="element-67">
                <Handshake className="w-5 h-5" data-id="element-68" />
              </div>
              <div data-id="element-69">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-70">
                  Government Partnerships
                </h3>
                <p className="text-slate-400" data-id="element-71">
                  Integrate directly with existing municipal waste management
                  programs to secure long-term feedstock supply.
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-72">
              <div className="w-12 h-12 rounded-full bg-slate-800 border border-slate-700 flex items-center justify-center shrink-0 text-slate-300" data-id="element-73">
                <BadgeDollarSign className="w-5 h-5" data-id="element-74" />
              </div>
              <div data-id="element-75">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-76">
                  Competitive Pricing
                </h3>
                <p className="text-slate-400" data-id="element-77">
                  Offer cost-stable, below-market energy rates to secure
                  long-term Power Purchase Agreements (PPAs).
                </p>
              </div>
            </div>

            <div className="flex gap-4" data-id="element-78">
              <div className="w-12 h-12 rounded-full bg-emerald-500/20 border border-emerald-500/50 flex items-center justify-center shrink-0 text-emerald-400" data-id="element-79">
                <FlaskConical className="w-5 h-5" data-id="element-80" />
              </div>
              <div data-id="element-81">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-82">
                  Pilot Programs
                </h3>
                <p className="text-slate-400" data-id="element-83">
                  Deploy modular pilot systems to validate AI efficiency and
                  establish operational benchmarks before full-scale rollout.
                </p>
              </div>
            </div>
          </div>

          {/* Pilot Highlight Card with image */}
          <div className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-3xl overflow-hidden border border-slate-700 relative shadow-2xl" data-id="element-84">
            {/* Background image */}
            <div className="absolute inset-0 z-0" data-id="element-85">
              <img src="https://images.unsplash.com/photo-1497435334941-8c899ee9e8e9?q=80&w=2074&auto=format&fit=crop" alt="Modern industrial facility" className="w-full h-full object-cover opacity-20" data-id="element-86" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/80 to-slate-800/90" data-id="element-87"></div>
            </div>

            <div className="relative z-10 p-8" data-id="element-88">
              <div className="absolute top-0 right-0 p-6 opacity-10 pointer-events-none" data-id="element-89">
                <Rocket className="w-32 h-32 text-white" data-id="element-90" />
              </div>

              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-emerald-500/20 text-emerald-400 text-xs font-bold uppercase tracking-wider mb-6 border border-emerald-500/30" data-id="element-91">
                <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" data-id="element-92"></span>
                Active Initiative
              </div>

              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-93">
                Sudbury Organic Recycling Pilot
              </h3>
              <p className="text-slate-400 mb-8" data-id="element-94">Launching Q1 2026</p>

              <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-95">
                <div className="bg-slate-950/50 rounded-xl p-4 border border-slate-800" data-id="element-96">
                  <div className="text-sm text-slate-500 mb-1" data-id="element-97">
                    Projected Revenue
                  </div>
                  <div className="text-2xl font-bold text-emerald-400" data-id="element-98">
                    $40K
                    <span className="text-sm text-slate-400 font-normal" data-id="element-99">
                      /mo
                    </span>
                  </div>
                </div>
                <div className="bg-slate-950/50 rounded-xl p-4 border border-slate-800" data-id="element-100">
                  <div className="text-sm text-slate-500 mb-1" data-id="element-101">Status</div>
                  <div className="text-lg font-bold text-white" data-id="element-102">
                    In Development
                  </div>
                </div>
              </div>

              <div className="w-full bg-slate-950 rounded-full h-2 mb-2" data-id="element-103">
                <div className="bg-emerald-500 h-2 rounded-full" style={{
                width: '65%'
              }} data-id="element-104"></div>
              </div>
              <div className="text-xs text-slate-500 text-right" data-id="element-105">
                65% to Launch
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}